import * as React from "react";
import { PracticeDetailsCard } from "../practice-management/PracticeDetailsCard";
import "./AppointmentCard.scss";
import AppointmentDetails from "./AppointmentDetails";
import * as moment from "moment";
import { fillTemplateString } from "../commons/utils/text-rendering";
import Label from "../label/Label";

export default function AppointmentCard({
  appointmentDetails,
  cancelAction,
}: {
  appointmentDetails: AppointmentDetails;
  cancelAction?: (appointmentDetails: AppointmentDetails) => void;
}) {
  const atMomentDateTime = moment.parseZone(appointmentDetails.atDateTime).locale(lang);
  const formattedDate = atMomentDateTime.format("dddd, MMMM D");
  const formattedStartTime = atMomentDateTime.format("LT");

  return (
    <div className="appointment-card">
      <div className="appointment-header h-flex space-between no-wrap align-center">
        <div>
          <div className="patient-info">
            {fillTemplateString(i18n["AppointmentCard.PatientInfo"], {
              name: appointmentDetails.patientName,
            })}
          </div>
          <div className="appointment-title">{appointmentDetails.title}</div>
        </div>
        {appointmentDetails.durationInMinutes && (
          <Label
            label={fillTemplateString(i18n["AppointmentCard.Duration"], {
              duration: appointmentDetails.durationInMinutes.toString(),
            })}
          />
        )}
      </div>
      <div className="appointment-content space-between align-center">
        <div className="practice-info">
          <h4>{i18n["AppointmentCard.PracticeInfo"]}</h4>
          <PracticeDetailsCard practiceDetails={appointmentDetails.practiceDetails} />
        </div>
        <div className="appointment-date">
          <div className="date">{formattedDate}</div>
          <div className="time">{formattedStartTime}</div>
        </div>
      </div>
      {cancelAction && (
        <div className="cancel-appointment">
          <hr />
          <button
            className="button-secondary small"
            onClick={() => cancelAction(appointmentDetails)}
          >
            {i18n["AppointmentCard.Action.Cancel"]}
          </button>
        </div>
      )}
    </div>
  );
}
